import { render, staticRenderFns } from "./SecondaryMenu.vue?vue&type=template&id=16b58d1c&scoped=true"
import script from "./SecondaryMenu.vue?vue&type=script&lang=js"
export * from "./SecondaryMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b58d1c",
  null
  
)

export default component.exports